import { useFlags } from '@rideiq/contexts/LDContext';

import { RiderCreationModal } from '../RiderCreationModal';

import { RiderFormPage } from './RiderFormPage';

type RiderFormEntryProps = {
  embedded?: boolean;
  isOpen?: boolean;
  handleClose?: () => void;
  handleSelectRider?: (selectedRider: unknown) => void;
};

export const RiderFormEntry = ({ embedded = false, isOpen, handleClose, handleSelectRider }: RiderFormEntryProps) => {
  const { iepStructuredNotesEnabled } = useFlags();
  const useNewForm = iepStructuredNotesEnabled;

  if (useNewForm) {
    return <RiderFormPage embedded={embedded} />;
  }

  return (
    <RiderCreationModal
      isOpen={isOpen ?? false}
      handleClose={handleClose ?? (() => undefined)}
      handleSelectRider={handleSelectRider ?? (() => undefined)}
    />
  );
};

export const RiderFormEntryEmbedded = () => <RiderFormEntry embedded />;
